import { isPriceNotation } from "../globalFormatterHelper";

/**
 * Returns true when a "Set Level" value is negative under a price notation
 * ($p, $fr). Zero is allowed (ARD quotes with 0).
 *
 * Used at submit time on the Send panel — the Order/RFQ gate is upstream,
 * so this helper only checks the value + notation combination.
 *
 * Handles both number and string forms — $fr fractions are signed by a leading
 * "-" (e.g. "-116-023"), and $p numeric strings by a leading "-" too.
 */
export function isNegativeLevelForPriceNotation(
  rawValue: number | string | undefined | null,
  notation: string | undefined,
): boolean {
  if (!isPriceNotation(notation)) return false;
  if (rawValue === undefined || rawValue === null || rawValue === "")
    return false;

  if (typeof rawValue === "number") return rawValue < 0;

  const trimmed = String(rawValue).trim();
  if (trimmed === "") return false;
  if (trimmed.startsWith("-")) return true;

  // Numeric string for $p without leading sign — safety net
  const asNum = Number(trimmed);
  if (!Number.isNaN(asNum)) return asNum < 0;

  return false;
}
